module.exports = __webpack_public_path__ + "img/moqing.46b4d770.png";